// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7061":"381a18b4","8042":"381a18b4","8687":"381a18b4"}[chunkId] + ".chunk.css";
};